<!--
 * @Description: 值班表
 * @Author: PF
 * @Date: 2023-09-18 17:13:25
 * @LastEditors: PF
 * @LastEditTime: 2024-08-23 15:35:34
-->
<template>
  <div>
    <el-dialog class="wp70 hp80" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <div>
            <span class="header-title">宿舍值班信息</span>
          </div>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="宿舍管理区域" v-model="dataGrid.parms.ssglqyid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in ssglqyData" :key="item.id" :label="item.qymc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker placeholder="值班日期" v-model="dataGrid.parms.rq" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" clearable @change="bindTable()"/>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="学期" prop="xqmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="值班人" prop="zbrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="日期" prop="rq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="时间" align="center">
                <template #default="scope">
                  <span v-if="scope.row.zbkssj && scope.row.zbjssj">{{ scope.row.zbkssj }}-{{ scope.row.zbjssj }}</span>
                </template>
              </el-table-column>
              <el-table-column label="宿舍管理区域" prop="ssglqymc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="80" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadList, loadSelect, homeCloseWindow } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import pagination from '@/components/pagination.vue'
import detail from '@/pages/sushe/zhibanguanli/sushezhibanbiao/detail.vue' // 值班表详情

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])


const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'rq', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/sushe/sushezhibanbiao/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
bindTable()
// 弹窗
const openList = ref(false)
const openDetail = ref(false)

const xqData = ref([])
const ssglqyData = ref([])
watch(
  () => props.open,
  () => {
    if (props.open === 'sushezhiban') {
      openList.value = true
      dataGrid.value.parms.zbrid = JSON.parse(sessionStorage.getItem('USER_INFO')).id
      dataGrid.value.parms.rq = getDate('YYYY', 'MM', 'DD')
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              dataGrid.value.parms.xqid = element.id
              bindTable()
            }
          })
        }
      })
      loadSelect({
        url: '/api/v2/sushe/susheguanliquyu/list',
        data: ssglqyData,
        order: 'qymc',
        sort: 'asc'
      })

      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
